import { Action, ThunkAction, configureStore } from "@reduxjs/toolkit";
import loggingUserSlice from "../features/loggingUser/loggingUserSlice";
import settingsSlice from "../features/settings/settingsSlice";
import itemsSlice from "../features/items/itemsSlice";
import materialsSlice from "../features/materials/materialsSlice";
import categoriesSlice from "../features/categories/categoriesSlice";
import partiesSlice from "../features/parties/partiesSlice";
import paymentsSlice from "../features/payments/paymentsSlice";
import materialOrdersSlice from "../features/materialOrders/materialOrdersSlice";
import materialPurchasesSlice from "../features/materialPurchases/materialPurchasesSlice";
import materialStocksSlice from "../features/materialStocks/materialStocksSlice";
import cuttingOrdersSlice from "../features/cuttingOrders/cuttingOrdersSlice";
import cuttingReceivesSlice from "../features/cuttingReceives/cuttingReceivesSlice";
import turningOrdersSlice from "../features/turningOrders/turningOrdersSlice";
import turningReceivesSlice from "../features/turningReceives/turningReceivesSlice";
import vmcOrdersSlice from "../features/vmcOrders/vmcOrdersSlice";
import vmcReceivesSlice from "../features/vmcReceives/vmcReceivesSlice";
import usersSlice from "../features/users/usersSlice";
import employeesSlice from "../features/employees/employeesSlice";
import salariesSlice from "../features/salaries/salariesSlice";
import accountTypesSlice from "../features/accounts/accountTypesSlice";
import accountsSlice from "../features/accounts/accountsSlice";
import activityLogsSlice from "../features/activityLogs/activityLogsSlice";
import appSettingsSlice from "../features/appSettings/appSettingsSlice";
import sessionsSlice from "../features/sessions/sessionsSlice";
import businessReportSlice from "../features/businessReport/businessReportSlice";
import listStateSlice from "../features/listState/listStateSlice";

export const store = configureStore({
  reducer: {
    loggingUser: loggingUserSlice,
    settings: settingsSlice,
    items: itemsSlice,
    materials: materialsSlice,
    categories: categoriesSlice,
    parties: partiesSlice,
    payments: paymentsSlice,
    materialOrders: materialOrdersSlice,
    materialPurchases: materialPurchasesSlice,
    materialStocks: materialStocksSlice,
    cuttingOrders: cuttingOrdersSlice,
    cuttingReceives: cuttingReceivesSlice,
    turningOrders: turningOrdersSlice,
    turningReceives: turningReceivesSlice,
    vmcOrders: vmcOrdersSlice,
    vmcReceives: vmcReceivesSlice,
    users: usersSlice,
    employees: employeesSlice,
    salaries: salariesSlice,
    accountTypes: accountTypesSlice,
    accounts: accountsSlice,
    activityLogs: activityLogsSlice,
    appSettings: appSettingsSlice,
    sessions: sessionsSlice,
    businessReport: businessReportSlice,
    listState: listStateSlice,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
